import * as React from "react"
import { useEffect } from "react"
import { Grid } from "@mui/material"

import { SKU_DUPLICATES_ROUTES } from "@constants"
import PageWrapper from "Pages/@PageWrapper"
import { clearSkuDuplicatesSignals } from "./@signals"
import { useSkuDuplicates } from "./@hooks"
import SkuDuplicatesFilters from "./Filters"
import SkuDuplicatesList from "./List"
import EditMappingDrawer from "./EditMappingDrawer"
import ImageComparisonModal from "./ImageComparisonModal"


export default function SkuDuplicatesPage() {
    // Initialize hook to handle data fetching
    useSkuDuplicates()

    useEffect(() => {
        return clearSkuDuplicatesSignals
    }, [])

    return <PageWrapper
        head={SKU_DUPLICATES_ROUTES.TITLE}
        title={SKU_DUPLICATES_ROUTES.TITLE}
        subtitle={SKU_DUPLICATES_ROUTES.SUBTITLE}
        actions={null}
    >
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <SkuDuplicatesFilters />
            </Grid>

            <Grid item xs={12}>
                <SkuDuplicatesList />
            </Grid>
        </Grid>

        <EditMappingDrawer />
        <ImageComparisonModal />
    </PageWrapper>
}
